import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccessUserInfo, UserDetail } from 'src/app/models';

@Component({
  selector: 'bart-lab-manager',
  templateUrl: './lab-manager.component.html',
  styleUrls: ['./lab-manager.component.scss']
})
export class LabManagerComponent implements OnInit {
  
  userDetail :UserDetail  =null;
  showMenu:boolean = true;
  activeTab: string ="active-inactive-labs";
  activeTabIndex:number=0;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.userDetail = AccessUserInfo.getUserInfo();
    this.route.queryParams
      .subscribe(params => {
        console.log(params.index); // { orderby: "price" }
        if(params.index==1){
          this.activeTab="lab-by-model";
          this.activeTabIndex=params.index;
        }
      }
    );
  }

  public handleChange(event)
  { 
    if (event.index== 0)
    {
      this.activeTab = "active-inactive-labs";
    }
    if (event.index== 1)
    {
      this.activeTab = "lab-by-model";
    }
    if (event.index== 2)
    {
      this.activeTab = "lab-frequency-alert";
    }
    if (event.index== 3)
    {
      this.activeTab = "lab-range-alert";
    }
     
  }
}
